import React from 'react';
import { Grid } from '@mui/material';
import { AdminAnalyticsContext } from '../contexts/AdminAnalyticsContext';
import OrdersTotalCharts from './OrdersTotalCharts';
import OrdersAverageCharts from './OrdersAverageCharts';

const OrdersCharts: React.FunctionComponent = () => {
  const { showAverage } = React.useContext(AdminAnalyticsContext);

  return (
    <>
      <Grid container spacing={3}>
        {showAverage === 'Total' ? (
          <Grid item xs={12} md={6}>
            <OrdersTotalCharts />
          </Grid>
        ) : (
          <Grid item xs={12} md={6}>
            <OrdersAverageCharts />
          </Grid>
        )}
      </Grid>
    </>
  );
};

export default OrdersCharts;
